import React from 'react';
import header from '../../assets/images/slide2.jpg';
import 'react-slideshow-image/dist/styles.css'
import slideOne from 'assets/images/slider/adslsl.jpg'
import slideTwo from 'assets/images/slider/fibersl.jpg'
import slideThree from 'assets/images/slider/owasl.jpg'
import slideFour from 'assets/images/slider/464-33-4.jpg'
import { Slide } from 'react-slideshow-image';
function Hero({ children }) {
  const spanStyle = {
    padding: '20px',
    background: '#efefef',
    color: '#000000'
  }
  
  const divStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundSize: 'contain',
    backgroundRepeat:'no-repeat',
    width:'100%',
    height: '400px'
  }
  const indicators = (index) => (<div className="indicator"></div>);
  const slideImages = [
    {
      url:slideOne,
      caption: 'Slide 1'
    },
    {
      url: slideTwo,
      caption: 'Slide 2'
    },
    {
      url: slideThree,
      caption: 'Slide 3'
    },
    {
      url: slideFour,
      caption: 'Slide 4'
    },
  ];
  return (
    <div className="slide-container">
      
        <Slide indicators={indicators}>
         {slideImages.map((slideImage, index)=> (
            <div key={index}>
              {/* <div style={{ ...divStyle, 'backgroundImage': `url(${slideImage.url})` }}>
                
              </div> */}
              <img src={slideImage.url} width={'100%'} height="auto"/>
            </div>
          ))} 
        </Slide>
      </div>
  );
}

export default Hero;
